import moment from "moment"
import { isFeatureEnabled } from "config/features"

export const BOOKING_REQUEST_TYPES = {
  REQUESTED: "booking request",
  UPCOMING: "upcoming",
  CANCELED: "canceled",
  COMPLETED: "completed"
}

export const PAYMENT_STATUS = {
  PAID: "paid",
  OUTSTANDING: "payment outstanding",
  PENDING: "pending",
  REFUNDED: "refunded",
  PARTIALLY_REFUNDED: "partially_refunded"
}

export const displayPaymentStatus = (payment_status) => {
  const status = {
    full_paid: "Paid",
    unpaid: "Unpaid",
    outstanding: "Payment Outstanding",
    pending: "Pending",
    partial_refund: "Partially Refunded",
    partially_refunded: "Partially Refunded", // Handle underscore variant from API
    refunded: "Refunded"
  }
  return status[payment_status] || "Unknown"
}

export const bookingActionsBasedOnStatus = ({
  status: { booking_status = "", payment_status = "", isExpired = false },
  handlers: {
    cancel: handleCancelBooking,
    accept: handleAcceptBooking,
    decline: handleDeclineBooking,
    bookAgain: handleBookAgain,
    edit: handleEditBooking
  }
}) => {
  if (booking_status === BOOKING_REQUEST_TYPES.UPCOMING) {
    const actions = [
      {
        key: "cancel",
        label: "Cancel Booking",
        onClick: handleCancelBooking,
        variant: "outlined",
        danger: true
      }
    ]

    // Only show Edit button if feature is enabled
    if (isFeatureEnabled('EDIT_BOOKING')) {
      actions.push({
        key: "edit",
        label: "Edit",
        onClick: handleEditBooking,
        type: "primary"
      })
    }

    return actions
  }
  if (booking_status === BOOKING_REQUEST_TYPES.REQUESTED) {
    return [
      {
        key: "decline",
        label: "Decline",
        onClick: isExpired ? () => {} : handleDeclineBooking,
        variant: "outlined",
        color: "primary",
        disabled: isExpired
      },
      {
        key: "accept",
        label: "Accept",
        onClick: isExpired ? () => {} : handleAcceptBooking,
        type: "primary",
        disabled: isExpired
      }
    ]
  }
  if (booking_status === BOOKING_REQUEST_TYPES.COMPLETED) {
    const actions = [
      {
        key: "cancel",
        label: "Cancel Booking",
        onClick: handleCancelBooking,
        variant: "outlined",
        danger: true
      }
    ]
    if (payment_status === PAYMENT_STATUS.PAID || payment_status === PAYMENT_STATUS.OUTSTANDING) {
      actions.push({
        key: "book_again",
        label: "Book Again",
        onClick: handleBookAgain,
        variant: "outlined",
        color: "primary"
      })
    }
    return actions
  }
  if (booking_status === BOOKING_REQUEST_TYPES.CANCELED) {
    if (payment_status === PAYMENT_STATUS.PAID || payment_status === PAYMENT_STATUS.OUTSTANDING) {
      return [
        {
          key: "cancel",
          label: "Cancel Booking",
          onClick: handleCancelBooking,
          variant: "outlined",
          danger: true
        },
        {
          key: "book_again",
          label: "Book Again",
          onClick: handleBookAgain,
          variant: "outlined",
          color: "primary"
        }
      ]
    }
  }
}

export const getBookingDateTime = (booking_date, booking_time) => {
  if (booking_date && booking_time) {
    return moment(`${booking_date} ${booking_time}`)?.format("MM/DD/YYYY, hh:mm A")
  }
  if (booking_date) {
    return moment(booking_date)?.format("MM/DD/YYYY")
  }
  if (booking_time) {
    return moment(booking_time, "HH:mm:ss")?.format("hh:mm A")
  }
}

export const getFormattedBookingDate = (booking_date) => {
  if (!booking_date) return ""
  return moment(booking_date)?.format("MM/DD/YYYY, hh:mm A")
}
